import { combineEpics, ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';

import { rs } from 'core/api';
import { reduxSwitch } from 'core/redux/tools';
import { internalizePage, timestamps } from 'core/redux/serializers';
import { ActionGeneratorBuilder, errorMap } from 'core/redux/actions';

const defaultPageSize = 10;

const internalize = timestamps(['createdAt', 'seenAt', 'sinceAt']).internalize;

export const actions = new ActionGeneratorBuilder('veta-entry-passes-companies')
	.subtype('load', (load) =>
		load.request({ no: false, size: false, sort: false, search: false }).success({ page: true }).fail(),
	)
	.subtype('add', (add) => add.request({ name: true }).fail())
	.build();

const defaultState = {
	page: null,
	pending: false,
	error: null,
	pageParams: { no: 1, search: undefined, size: 10, sort: undefined },
};

const companiesReducer = (state, action) => {
	switch (action.type) {
		case actions.load.request.type:
			return {
				...state,
				pending: true,
				error: null,
				pageParams: { no: action.no, size: action.size, sort: action.sort, search: action.search },
			};
		case actions.add.request.type:
			return { ...state, pending: true, error: null };
		case actions.load.success.type:
			return { ...state, pending: false, page: action.page };
		case actions.load.fail.type:
		case actions.add.fail.type:
			return { ...state, pending: false, error: action.errorMessage };
		default:
			return state;
	}
};

export const reducer = reduxSwitch([companiesReducer], defaultState);

const loadEpic = (action$) => {
	return action$.pipe(
		ofType(actions.load.request.type),
		switchMap((action) =>
			rs('veta/entry-passes/companies/page')
				.optional('no', action.no)
				.optional('sort', action.sort)
				.optional('search', action.search)
				.param('size', action.size | defaultPageSize)
				.defer$()
				.pipe(
					map(internalizePage(action.size | defaultPageSize, internalize)),
					map((page) => actions.load.success({ page })),
					errorMap(actions.load.fail),
				),
		),
	);
};

const addEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.add.request.type),
		switchMap((action) =>
			rs('veta/entry-passes/companies')
				.post({ name: action.name })
				.defer$()
				.pipe(
					map(() => actions.load.request(state$.value.veta.tep.companies.pageParams)),
					errorMap(actions.add.fail),
				),
		),
	);
};

export const epic = combineEpics(loadEpic, addEpic);
